import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithErrorHandling } from './baseQuery';

export interface PortalLinkResponse {
  matter_id: string;
  portal_url: string;
  token: string;
  created: boolean;
}

export const clientPortalApiClient = createApi({
  reducerPath: 'clientPortalApi',
  baseQuery: baseQueryWithErrorHandling,
  tagTypes: ['ClientPortal'] as const,
  endpoints: (builder) => ({
    getPortalLink: builder.query<PortalLinkResponse, string>({
      query: (matter_id) => `api/matters/${matter_id}/portal-link/`,
      providesTags: ['ClientPortal'],
    }),
  }),
});

export const { useGetPortalLinkQuery, useLazyGetPortalLinkQuery } =
  clientPortalApiClient;
